import { useTheme } from 'styled-components';

import { Typography } from '../../../designComponents';
import { useResponsive } from '../../../hooks/useResponsive';
import { columns, columns1, data, data1 } from './data';
import { ContainerStyled, PricingCompareStyled } from './style';
import Table from './Table';

const PricingComparision = () => {
  const theme = useTheme();

  const { isTablet } = useResponsive();
  return (
    <PricingCompareStyled>
      <ContainerStyled>
        <div className="main-text">
          <Typography
            style={{ color: theme.colors.landingSecondaryText }}
            className="head-text"
          >
            Pricing Plan{' '}
            <span style={{ color: theme.colors.primary }}>Comparison</span>
          </Typography>
          <Typography className="main-desc">
            Explore the differences between our pricing packages to find the
            perfect fit for your project needs.
          </Typography>
        </div>
        <div style={{ width: '100%' }}>
          {isTablet ? (
            <Table data={data1} columns={columns1} />
          ) : (
            <Table data={data} columns={columns} />
          )}
        </div>
      </ContainerStyled>
    </PricingCompareStyled>
  );
};

export default PricingComparision;
